/*
UNIT-SEARCH
Search units by name (finder only, does not filter list)
*/
import { useState, useMemo } from "react"
import { useAppSelector } from "@/core/root-reducer"
import unitStore from "../model/unit.store"
import SearchBar from "@/components/search-bar"
import ListItem from "@/components/list-item"
import { t } from "i18next"
import { useFocusOnNode } from "../hooks/useFocusOnNode"
import { Unit } from "../model/unit.types"
import ContextMenu from "@/components/context-menu"

interface Props {
  onSelectUnit?: (unit: Unit | null) => void
}

export default function UnitSearch({ onSelectUnit }: Props) {
  const allUnits = useAppSelector(unitStore.selectors.list)
  const [query, setQuery] = useState("")

  const { focusOnNode } = useFocusOnNode()

  const results = useMemo(() => {
    if (!query) return []
    return allUnits.filter((u: any) => u.name?.toLowerCase().includes(query.toLowerCase()))
  }, [query, allUnits])

  const handleSearchUnit = (u: Unit) => {
    if (onSelectUnit) {
      onSelectUnit(u)
    } else {
      focusOnNode(u.id, 1.2, 500, true)
    }
    setQuery("")
  }

  return (
    <div className="w-[250px] relative">
      <SearchBar
        searchText={query || undefined}
        onSearch={(val) => {
          setQuery(val || "")
          if (!val) onSelectUnit?.(null)
        }}
      />

      {query && (
        <ContextMenu>
          {results.length > 0 ? (
            results.map((u: Unit) => (
              <ListItem
                isSmall
                key={u.id}
                className="hover:bg-gray-100 cursor-pointer"
                onClick={() => handleSearchUnit(u)}>
                {u.name}
              </ListItem>
            ))
          ) : (
            <ListItem className="text-gray-400 italic">{t("Aucun résultat")}</ListItem>
          )}
        </ContextMenu>
      )}
    </div>
  )
}
